import {FC, useCallback, useState} from 'react';

import {Box, DialogContent, IconButton} from '@mui/material';
import {t} from 'i18next';
import {When} from 'react-if';

import {CloseIcon} from 'assets/icons/closeIcon';
import InfoIconLight from 'assets/icons/infoIcon';
import InfoIcon from 'assets/icons/infoIcon';
import {AdvancedPromotions} from 'types';

import {ModalContent, StyledDialogTitle, StyledDiscountDescription, StyledModal, StyledSection} from './styles';

interface DiscountPopupIconProps {
  advancedPromotions?: AdvancedPromotions[];
  iconVariant?: 'dark' | 'light';
}

export const DiscountPopupIcon: FC<DiscountPopupIconProps> = (props: DiscountPopupIconProps) => {
  const {advancedPromotions, iconVariant = 'dark'} = props;
  const [opened, setOpened] = useState(false);
  const onClose = useCallback(() => {
    setOpened(false);
  }, []);

  const onOpen = useCallback(() => {
    setOpened(true);
  }, []);
  return (
    <>
      <Box display="flex" onMouseOver={onOpen}>
        <When condition={iconVariant === 'dark'}>
          <InfoIcon fontSize={'small'} />
        </When>
        <When condition={iconVariant === 'light'}>
          <InfoIconLight />
        </When>
      </Box>
      <StyledModal open={opened} onClose={onClose}>
        <StyledDialogTitle>
          {t('label.discount')}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[900]
            }}
          >
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <DialogContent>
          <ModalContent>
            {advancedPromotions?.map((item, index: number) => {
              return (
                <StyledSection key={`shipping-fee-item-${index}`}>
                  <StyledDiscountDescription>
                    <div>{item.description}</div>
                  </StyledDiscountDescription>
                </StyledSection>
              );
            })}
          </ModalContent>
        </DialogContent>
      </StyledModal>
    </>
  );
};
